import { AfterViewInit, Component, ViewChild } from "@angular/core";
import { confirm } from 'devextreme/ui/dialog';
import { DxDataGridComponent } from "devextreme-angular";
import { NotificationService } from "../common/component/notification/notification.service";
import { ScreenService } from "../services/screen.service";
import { PipelineService } from "./pipelines.service";
import { MasterDataService } from "../common/service/master-data.service";
import { ActivatedRoute } from "@angular/router";

@Component({
    selector: 'app-pipelines',
    templateUrl: './pipelines.component.html',
    styleUrls: ['./pipelines.component.scss']
})

export class PipelinesComponent implements AfterViewInit {

    @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;
    materials: any[];
    pipelines: any[];
    suppliers: any[];
    countries: any[];
    states: any[];
    pipelineId: number = 0;
    selectedPipeline: string = '';

    isLoadPanelVisible: boolean = false;
    supplyConnections: any[];
    sites: any;
    customerConnections: any[];
    materialId: number;
    materialName: string;
    searchModeOption = 'contains';
    readonly allowedPageSizes = [50, 100, 200];

    searchExprOption: any = 'materialName';
    uoms: any[];
    allUoms: any[];
    showGrid: boolean = false;
    isNewSupplier: boolean = false;

    constructor(private route: ActivatedRoute, private screenService: ScreenService, private pipelineService: PipelineService, private notificationService: NotificationService, private masterDataService: MasterDataService) {
        this.screen = this.screen.bind(this);
        this.getSites();
        this.getMaterials();
        this.getFilteredStates = this.getFilteredStates.bind(this);
        this.onSaveClick = this.onSaveClick.bind(this);
        this.onCancelClick = this.onCancelClick.bind(this);
    }

    ngAfterViewInit(): void {
        this.pipelineService.getUoms().subscribe({
            next: uoms => {
                this.allUoms = uoms;
                this.route.params.subscribe(params => {
                    if (params['pipelineId'] != null) {
                        this.pipelineId = Number(params['pipelineId']);
                    }

                    if (params['materialId'] != null) {
                        this.materialId = Number(params['materialId']);
                    }
                });
            }, error: (error) => {
                this.notificationService.alert("error", "Error while fetching UOMs", error);
            }
        });


    }

    screen(width) {
        return this.screenService.screenSize;
    }

    resetFilters() {
        this.dataGrid.instance.clearFilter();
        this.dataGrid.instance.clearSorting();
    }

    addRow() {
        this.dataGrid.instance.addRow();
    }

    setLoadPanelVisibility(data) {
        this.isLoadPanelVisible = data;
    }

    onMaterialChange(e) {
        this.materialName = e.component.option("text");
        this.getFilteredUoms(e.value);
        this.getPipeline(e.value);
        this.getSuppliers();

        this.isLoadPanelVisible = true;

        this.masterDataService.getCountries().subscribe({
            next: countries => {
                this.countries = countries;
                this.isLoadPanelVisible = false;
                this.showGrid = true;
            }, error: (error) => {
                this.notificationService.alert("error", "Error while fetching Countries", error);
                this.isLoadPanelVisible = false;
            }
        });

        this.masterDataService.getProvinces().subscribe({
            next: states => {
                this.states = states;
                this.isLoadPanelVisible = false;
                this.showGrid = true;
            }, error: (error) => {
                this.notificationService.alert("error", "Error while fetching States", error);
                this.isLoadPanelVisible = false;
            }
        });
    }

    supplierColumnOptions = {
        acceptCustomValue: true,
        onCustomItemCreating: function (args) {
            if (args.text) {
                this.isNewSupplier = true;
                var newItem = { supplierName: "" };
                newItem.supplierName = args.text;

                this.suppliers.unshift(newItem);

                setTimeout(() => {
                    this.dataGrid.instance.columnOption("supplier", "lookup", {
                        dataSource: this.suppliers,
                        displayExpr: "supplierName",
                        valueExpr: "supplierName"
                    });
                });

                return newItem;
            }
        }.bind(this)
    }

    addPipeline(event) {
        event.data.pipelineCode = event.data.supplier + '-' + event.data.country + '-' + event.data.stateProvince;
        if (event.data.city) {
            event.data.pipelineCode = event.data.pipelineCode + '-' + event.data.city;
        } else {
            event.data.city = '';
        }

        event.data.pipelineId = 0;
        event.data.materialId = this.materialId;

        this.pipelineService.addPipeline(event.data).subscribe({
            next: pipelines => {
                if (this.isNewSupplier) {
                    this.getSuppliers();
                }
                this.isNewSupplier = false;
                this.pipelines = pipelines;
                this.notificationService.alert('success', 'Pipeline created successfully!', null);
            }, error: (error) => {
                this.notificationService.alert("error", "Error while creating pipeline", error);
            }
        });
    }

    updatePipeline(event) {
        event.data.pipelineCode = event.data.supplier + '-' + event.data.country + '-' + event.data.stateProvince;
        if (event.data.city) {
            event.data.pipelineCode = event.data.pipelineCode + '-' + event.data.city;
        }

        this.pipelineService.updatepiPeline(event.data).subscribe({
            next: pipelines => {
                if (this.isNewSupplier) {
                    this.getSuppliers();
                }
                this.isNewSupplier = false;
                this.pipelines = pipelines;
                this.notificationService.alert('success', 'Pipeline updated successfully!', null);
            }, error: (error) => {
                this.notificationService.alert("error", "Error while updating pipeline", error);
            }
        });
    }

    onSaveClick(e) {
        this.dataGrid.instance.saveEditData();
    }

    onCancelClick(e) {
        let that = this;
        var result = confirm("Your changes will be lost. Are you sure?", "Confirm");
        result.then(function (dialogResult) {
            if (dialogResult) {
                that.dataGrid.instance.cancelEditData();
            }
        });

    }

    onInitNewRow(event) {
        event.data.isActive = true;
        event.data.multiCustomerPipeline = false;
        event.data.materialId = this.materialId;
    }

    getFilteredStates(options) {
        return {
            store: this.states,
            filter: options.data ? ['country', '=', options.data.country] : null,
        };
    }

    onEditorPreparing(e) {
        if (e.parentType === 'dataRow' && e.dataField === 'stateProvince') {
            e.editorOptions.disabled = !(e.row.data.country);
        }

        if (e.dataField == "pipelineCode") {
            e.editorOptions.readOnly = true;
        }
    }

    setStateValue(rowData: any, value: any): void {
        (<any>this).defaultSetCellValue(rowData, value);
    }

    setCountryValue(rowData: any, value: any): void {
        rowData.stateProvince = null;
        (<any>this).defaultSetCellValue(rowData, value);
    }

    setCityValue(rowData: any, value: any): void {
        (<any>this).defaultSetCellValue(rowData, value);
    }

    setPipelineCodeValue(rowData: any, value: any): void {
        (<any>this).defaultSetCellValue(rowData, value);
    }

    setSupplierValue(rowData: any, value: any): void {
        (<any>this).defaultSetCellValue(rowData, value);
    }

    getPipeline(materialName: any) {
        this.isLoadPanelVisible = true;
        this.pipelineService.getPipelines(materialName).subscribe({
            next: pipelines => {
                this.pipelines = pipelines;
                this.isLoadPanelVisible = false;
                this.showGrid = true;
                if (this.pipelineId > 0) {
                    this.selectPipeline();
                }
            }, error: (error) => {
                this.notificationService.alert("error", "Error while fetching Pipelines", error);
                this.isLoadPanelVisible = false;
            }
        });
    }

    selectPipeline() {
        this.selectedPipeline = this.pipelines.find(x => x.pipelineId == this.pipelineId).pipelineCode;
    }

    getSuppliers() {
        this.isLoadPanelVisible = true;
        this.pipelineService.getSuppliers().subscribe({
            next: suppliers => {
                this.isNewSupplier = false;
                this.suppliers = suppliers;
                this.isLoadPanelVisible = false;
                this.showGrid = true;
            }, error: (error) => {
                this.notificationService.alert("error", "Error while fetching Suppliers", error);
                this.isLoadPanelVisible = false;
            }
        });
    }

    getFilteredUoms(materialName: any) {
        let filteredUOMs = this.allUoms.filter(x => x.productId == materialName);
        if (filteredUOMs.length == 1 && filteredUOMs[0].fromUOM == 'Manual') {
            filteredUOMs = this.allUoms.filter(x => x.fromUOM != 'Manual');
            this.uoms = [...new Map(filteredUOMs.map(item => [item['fromUOM'], item])).values()];
        } else {
            this.uoms = filteredUOMs;
        }
    }

    getMaterials() {
        this.isLoadPanelVisible = true;
        this.pipelineService.getMaterials().subscribe({
            next: materials => {
                this.materials = materials;
                this.isLoadPanelVisible = false;
            }, error: (error) => {
                this.isLoadPanelVisible = false;
                this.notificationService.alert("error", "Error while fetching Materials", error);
            }
        });
    }

    getSites() {
        this.pipelineService.getSites().subscribe({
            next: sites => {
                this.sites = {
                    store: sites,
                    paginate: true,
                    pageSize: 20
                };
            }, error: (error) => {
                this.notificationService.alert("error", "Error while fetching Sites", error);
            }
        });
    }
}